import { useTableRowManipulation } from '../../../../SidePanel/content/TableSettings/RowSettings/useTableRowManipulation';
import Checkbox from '@mui/material/Checkbox';

const OptionalRowInput = ({ id, isRowOptional, disabled }: { id: string; isRowOptional: boolean; disabled?: boolean }) => {
  const { toggleRowProperty } = useTableRowManipulation();

  const label = { inputProps: { 'aria-label': 'Optional row' } };
  const handleCheckboxChange = async () => {
    await toggleRowProperty('isRowOptional', !isRowOptional, id);
  };

  return (
    <Checkbox
      data-testid="row-optional-chekbox"
      className="py-row-optional"
      {...label}
      onChange={handleCheckboxChange}
      checked={isRowOptional}
      disabled={disabled}
    />
  );
};

export default OptionalRowInput;
